export const ADDRESS_FORM = {
    BILLING_ADDRESS: 'billingAddress',
    DELIVERY_ADDRESS: 'deliveryAddress',
    ADDRESS_MATCH: 'addressMatch',
} as const;
